import Api from './api'

export default {
  install(Vue) {
    Vue.$Api = Vue.prototype.$Api = new Api()
  }
}
